import React, { useState } from 'react'
import { Col, FormGroup, Input, Label } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Btn, H2, H6, Image, P } from '../AbstractElements';
import { dynamicImage } from '../Utils';
import { CreateAccount, DontHaveAccount, EmailAddress, ForgotPassword, Password, RememberPassword, SignIn, SignInAccount, SignInWith } from '../Utils/Constants';
import SocialLink from './SocialLink';
import { useForm, Controller, FieldError } from "react-hook-form";
import axios from "axios";
import { baseUrl, mediaUrl } from '../Utils';
import { useAuth } from '../Context/AuthContext';
import { useConfig } from '../Context/ConfigContext';

type FormData = {
    email: string;
    password: string;
};

export default function SignInForm() {
    const navigate = useNavigate();
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<FormData>();

    const { setAuthData } = useAuth();
    const { config } = useConfig();
    const logoSrc = config.logo ? `${mediaUrl}${config.logo}` : dynamicImage(`logo/logo1.png`);

    const toggle = () => setPasswordVisible(!isPasswordVisible);

    const onSubmit = async (data: FormData) => {
        setLoading(true);
        try {
            const response = await axios.post(`${baseUrl}login`, {
                email: data.email,
                password: data.password
            });

            const { token, user, permissions } = response.data;

            localStorage.setItem("token", token);
            localStorage.setItem("login", JSON.stringify(true));
            localStorage.setItem("user", JSON.stringify(user));

            setAuthData(user.role, permissions || [], user);

            navigate(`${process.env.PUBLIC_URL}/dashboard`);
        } catch (error: any) {
            const msg = error.response?.data?.message || "Login failed. Please check your credentials.";
            toast.error(msg, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div>
                <Link className='logo' to={`${process.env.PUBLIC_URL}/dashboard`}>
                    <Image className="img-fluid for-light m-auto" src={logoSrc} alt="looginpage" style={{ width: "50%" }} />
                    <Image className="img-fluid for-dark" src={logoSrc} alt="looginpage" style={{ width: "50%" }} />
                </Link>
            </div>
            <div className="login-main">
                <form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
                    <H2 className="text-center">{SignInAccount}</H2>
                    <P className="text-center">{"Enter your email & password to login"}</P>

                    <FormGroup>
                        <Col><Label>{EmailAddress}</Label></Col>
                        <Controller
                            name="email"
                            control={control}
                            defaultValue=""
                            rules={{
                                required: "Email is required",
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: "Invalid email address"
                                }
                            }}
                            render={({ field }) => (
                                <Input
                                    {...field}
                                    type="email"
                                    placeholder="Test@gmail.com"
                                    invalid={!!errors.email}
                                />
                            )}
                        />
                        {errors.email && <span className="text-danger">{(errors.email as FieldError).message}</span>}
                    </FormGroup>

                    <FormGroup>
                        <Col><Label>{Password}</Label></Col>
                        <div className="form-input position-relative">
                            <Controller
                                name="password"
                                control={control}
                                defaultValue=""
                                rules={{ required: "Password is required" }}
                                render={({ field }) => (
                                    <Input
                                        {...field}
                                        type={isPasswordVisible ? 'text' : 'password'}
                                        placeholder="********"
                                        invalid={!!errors.password}
                                    />
                                )}
                            />
                            <div className='show-hide' onClick={toggle}>
                                <span className={!isPasswordVisible ? 'show' : ''}></span>
                            </div>
                        </div>
                        {errors.password && <span className="text-danger">{(errors.password as FieldError).message}</span>}
                    </FormGroup>

                    <FormGroup className="mb-0 checkbox-checked">
                        <Link className="link" to={`${process.env.PUBLIC_URL}/forget_password`}>{ForgotPassword}</Link>
                        <div className="text-end mt-3">
                            <Btn color='primary' className="w-100" block disabled={loading}>{loading ? "Signing in..." : SignIn}</Btn>
                        </div>
                    </FormGroup>

                </form>
            </div>
            <ToastContainer />
        </div>
    )
}